import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

// ─── Self-service profile ───────────────────────────────────────────

export function getMyProfile(token: string) {
    return axios.get(`${API_V1_URL}/auth0/users/get/me`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export interface ProfileUpdatePayload {
    firstName: string;
    lastName: string;
    NumberPhone?: string;
    position?: string;
}

export function updateMyProfile(token: string, data: ProfileUpdatePayload) {
    return axios.put(`${API_V1_URL}/auth0/users/update/`, data, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

// ─── MFA Devices ────────────────────────────────────────────────────

export interface MfaDevice {
    id: string;
    type: string;
    name?: string;
    created_at: string;
    last_auth_at?: string;
}

export function getMyMfaDevices(token: string) {
    return axios.get<{ devices: MfaDevice[]; total: number }>(
        `${API_V1_URL}/auth0/users/me/mfa-devices`,
        { headers: { Authorization: `Bearer ${token}` } }
    );
}

export function deleteMyMfaDevice(token: string, methodId: string) {
    return axios.delete(
        `${API_V1_URL}/auth0/users/me/mfa-devices/${methodId}`,
        { headers: { Authorization: `Bearer ${token}` } }
    );
}

// ─── Activity Log ───────────────────────────────────────────────────

export interface ActivityLogEntry {
    date: string;
    type: string;
    description: string;
    ip: string;
    user_agent: string;
    log_id: string;
}

export function getMyActivityLog(
    token: string,
    page = 0,
    perPage = 20
) {
    return axios.get(
        `${API_V1_URL}/auth0/users/me/activity-log?page=${page}&per_page=${perPage}`,
        { headers: { Authorization: `Bearer ${token}` } }
    );
}

// ─── Password Reset ─────────────────────────────────────────────────

export function resetMyPassword(token: string) {
    return axios.post(
        `${API_V1_URL}/auth0/users/reset-password/me`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
    );
}

// ─── MFA Full Reset ─────────────────────────────────────────────────

export function resetAllMyMfa(token: string) {
    return axios.put(
        `${API_V1_URL}/auth0/users/mfa-reset`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
    );
}

// ─── MFA Enrollment ─────────────────────────────────────────────────

export function enrollMyMfa(token: string) {
    return axios.post<{ ticket_id: string; ticket_url: string }>(
        `${API_V1_URL}/auth0/users/me/mfa-enroll`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
    );
}
